
const prod = {
    url: {
        API_URL: `https://api.aprusa.apcfss.in/APRUSA/`,
        FILE_DOWNLOAD_URL: 'https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/affiliation-documents/',


    }
};
const protocol = window.location.protocol === "https:" ? "https" : "http";
const dev = {
    url: {

        API_URL: 'https://swapi.dev.nidhi.apcfss.in/APRUSA/', //DEV
        // FAC_URL: 'https://swapi.dev.nidhi.apcfss.in/APRUSA/fac/', //DEV

        FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,


    }
};

const local = {
    url: {
        API_URL: `${protocol}://172.16.119.131:8280/APRUSA/`, //Pavani  /
        // FAC_URL: `${protocol}://172.16.119.243:8280/APRUSA/fac/`, //Pavani  /

        // API_URL: 'https://swapi.dev.nidhi.apcfss.in/APRUSA/', //DEV
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,
        FILE_DOWNLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/`,

    }

};


export const config = process.env.NODE_ENV === 'development' ? dev : prod; 
